export default "__VITE_ASSET__d65df905__"